// const BASE_URL = "https://localhost:7231/api/Deduction";

import { BASE_URL } from "../config";


export const getAllDeduction = async () => {
  try {
    const response = await fetch(`${BASE_URL}/Deduction/deductions`);
    if (!response.ok) {
      throw new Error("Failed to fetch deductions");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching deductions:", error);
    throw error;
  }
};


//Add Deduction
export const addDeduction = async (deduction) => {
  try {
    const crUser = sessionStorage.getItem("username") || "guest";

    const response = await fetch(`${BASE_URL}/Deduction/deductions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...deduction,
        crUser: crUser,
        crDate: new Date().toISOString(),
        deleted: "N",
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add deduction");
    }

    return response.status === 201 ? true : await response.json();
  } catch (error) {
    console.error("Error adding deduction:", error);
    throw error;
  }
};

// Update Deduction
export const updateDeduction = async (id, deduction) => {
  try {
    const trUser = sessionStorage.getItem("username") || "admin"; // fallback user
    const trDate = new Date().toISOString();

    const response = await fetch(`${BASE_URL}/Deduction/deductions/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...deduction,
        trUser: trUser,
        trDate: trDate,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to update deduction");
    }

    // backend returns 200 on update
    if (response.status === 200) {
      return true;
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating deduction:", error);
    throw error;
  }
};


//Delete Deduction
export const deleteDeduction = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/Deduction/deductions/${id}`, {
      method: "DELETE",
    });

    if (response.status === 204) {
      return true;
    } else {
      throw new Error("Failed to delete deduction");
    }
  } catch (error) {
    console.error("Error deleting deduction:", error);
    throw error;
  }
};